import React, { Dispatch, SetStateAction } from "react";
import "./css/index.css";
type Props = {
  isOpen: boolean;
  ment: string;
  index: string;
  setDeleteIndex: Dispatch<SetStateAction<string | undefined>>;
  data: any;
  PostRemove: (data: any, index: string) => void;
};

const PostDeleteSection = ({
  isOpen,
  ment,
  index,
  setDeleteIndex,
  data,
  PostRemove,
}: Props) => {
  return (
    <>
      <button className={`common-delete-open-btn `}>
        <img
          src="/assets/common/delete.svg"
          onClick={() => {
            setDeleteIndex(index);
          }}
          alt="삭제"
        />
      </button>
      <div
        className={`common-delete-section ${isOpen ? "common-delete-on" : ""}`}
      >
        <div className="delete-ment">{ment}</div>
        <button
          className="post-delete-btn"
          onClick={() => {
            setDeleteIndex(undefined);
            PostRemove(data, index);
          }}
        >
          삭제하기
        </button>
      </div>
    </>
  );
};

export default PostDeleteSection;
